// src/utils/spacedRepetition.js

function clamp01(x) {
  return Math.max(0, Math.min(1, x));
}

/**
 * Decide how many days until a skill is "due" again.
 * Conservative spacing based on accuracy.
 */
export function spacingDaysFromAccuracy(accuracy) {
  const acc = clamp01(typeof accuracy === "number" ? accuracy : 0.45);

  if (acc < 0.45) return 2;     // weak → revisit soon
  if (acc < 0.65) return 4;     // developing
  if (acc < 0.85) return 8;     // secure-ish
  return 16;                    // strong → long spacing
}

/**
 * Compute whether a skill is due for revision.
 */
export function isSkillDue({ lastAttempt, accuracy, now = Date.now() }) {
  if (!lastAttempt) return true; // never seen → due
  const days = spacingDaysFromAccuracy(accuracy);
  const dueAt = lastAttempt + days * 24 * 60 * 60 * 1000;
  return now >= dueAt;
}

/**
 * A "due score" for ranking:
 * - skills that are overdue and weak should bubble up.
 */
export function duePriorityScore({ lastAttempt, accuracy, now = Date.now() }) {
  const acc = clamp01(typeof accuracy === "number" ? accuracy : 0.45);

  // overdueDays: how far past due we are (>= 0)
  const days = spacingDaysFromAccuracy(acc);
  const dueAt = (lastAttempt || 0) + days * 24 * 60 * 60 * 1000;
  const overdueMs = Math.max(0, now - dueAt);
  const overdueDays = overdueMs / (24 * 60 * 60 * 1000);

  // weak skills should rank higher
  const weakness = 1.1 - acc; // 0.1..1.1

  return overdueDays * 10 + weakness * 5;
}
